import React, { Component } from 'react';
import { connect } from 'react-redux';
import Axios from 'axios';

import Header from '@/components/Header';
import Newsletter from '../../components/_common/Newsletter';
import MetaDetail from '../../components/_common/MetaDetail';
import tracking from '../../utils/tracking';
import './welcome-back.scss';

class WelcomeBackPage extends Component {
	constructor(props) {
		super(props);
		this.getNewsletter();
	}

	async getNewsletter() {
		const baseURL = window.location.hostname !== 'localhost' ? window.location.hostname : 'www.guinnessopengate.com';

		await Axios.get(`https://cms.diageohorizon.com/PR1515/${baseURL}/en-gb/NEWSLETTER OVERLAY.json?v=${Math.random()}`)
			.then(response => {
				this.setState({ newsletterData: response.data.contents });
			});
	}

	componentDidMount() {
		tracking.pageView('/welcome-back');
	}

	render() {
		const title = this.state.title;
		const subhead = this.state.subhead;
		const welcomeItems = this.state.items;
		const newsletter = this.state.newsletterData;
		let newsletterContent = [];
		let signUpFormData = {};
		let signUpFormContents = {};

		const meta = {
			title: 'Welcome Back',
			description: 'Experience a seasonal beer and food pairing welcome like no other.',
			canonical: window.location.href
		};

		if (welcomeItems) {
			items = welcomeItems.map(item => this.Item(item));
		}

		if (newsletter != undefined) {
			for (let i = 0; i < newsletter.length; i++) {
				let fieldsObj = {};
				let contentKey = '';
				for (let field of newsletter[i].fields) {
					if (field.id === 'module') {
						switch (field.value) {
							case ('Sign up - overlay screen 1'):
								contentKey = 'Screen1';
								break;
							case ('Form field 1 - YOUR EMAIL'):
								contentKey = 'Field1';
								break;
							case ('Sign up - overlay screen 2'):
								contentKey = 'Screen2';
								break;
							case ('Sign up - already subscribed'):
								contentKey = 'Screen3';
								break;
							default:
								console.log('Unknown Key');
								break;
						}
						continue;
					}
					else if (field.id === 'modules-details') {
						for (let newsField of field.fields) {
							let fieldKey = newsField.title;
							let fieldVal = newsField;
							fieldsObj[fieldKey] = fieldVal;
						}
						continue;
					}
				}
				if (contentKey === 'Screen1') {
					newsletterContent.push(fieldsObj);
				}

				signUpFormContents[contentKey] = [];
				signUpFormContents[contentKey].push(fieldsObj);
			}

			signUpFormData.contents = signUpFormContents;
		}

		if (!signUpFormData) return null;
		signUpFormData.fetchedData = signUpFormData.built = true;

		let items = [
			{
				header: 'Opening Hours',
				copy: 'We’re open<br/ ><br/ >Thursday - Friday: 5.00pm to the last sitting at 8.00pm<br/ ><br/ >Saturday: 3.00pm to the last sitting at 8.00pm<br/ ><br/ >Sunday: 2.00pm to the last sitting at 6.00pm',
				color: 'blue'
			},
			{
				header: 'Beer',
				copy: 'Our creative brewers have been busy working away on a fresh line up of beers that have never been poured before. To see what’s pouring, check out our social channels <a href="https://twitter.com/OpenGateBrewery?ref_src=twsrc%5Egoogle%7Ctwcamp%5Eserp%7Ctwgr%5Eauthor" target="_blank">here</a>. We will also be serving some great local beers from our neighbours and friends in the Irish craft brewing scene.',
				color: 'red'
			},
			{
				header: 'Food',
				copy: 'We’re excited to launch a tasty new menu designed to be perfectly paired with our beers, so make sure to arrive hungry! Check out the menu <a href="https://www.guinnessopengate.com/menu" target="_blank">here</a>.',
				color: 'green'
			},
			{
				header: 'The Taproom & Beer Garden',
				copy: 'Tables will adhere to social distancing guidelines and will be spaced out to ensure you will feel safe and fully enjoy your visit.<br/><br/>Once you’re seated, we’ll take it from there. Our Beer Specialists will be at hand to chat you through our selection of beers and food with table service. Enjoy the full experience from the comfort of your seat.<br/>',
				color: 'blue'
			},
			{
				header: 'Your Safety',
				copy: 'At the Guinness Open Gate Brewery, your safety is our priority. From the friendly staff at our gates to the Beer Specialists on the floor, everyone at the Guinness Open Gate Brewery has completed the Fáilte Ireland Covid-19 Safety Charter training. We have hand sanitiser stations throughout the venue and have installed signage to ensure physical distancing. If you or anyone you’ve been in contact with has experienced <a href="https://www2.hse.ie/conditions/covid19/symptoms/overview/" target="_blank">Covid-19 symptoms</a> in the last 14 days, please reschedule your visit for a later time.<br/><br/>In line with the updated Irish Government regulations regarding indoor hospitality, customers will need to provide a valid photo ID and Proof of Immunity on arrival to confirm that all are over 18 and are either fully vaccinated or have recovered from COVID-19 in the past six months to access indoor dining.<br/><br/>To ensure the safety of other visitors and staff, guests are required to wear face coverings when arriving to and leaving their table. Maximum groups of ten adults can be accommodated.<br/><br/>If any of your party have travelled from oversees recently, please comply with the <a href="https://www.gov.ie/en/campaigns/75d92-covid-19-travel-advice/?referrer=http://www.gov.ie/en/publication/e885b2-covid-19-coronavirus-travel-advice/" target="_blank">travel advice of the Irish Department of Health</a>. In the event of a Covid-19 incident in the Guinness Storehouse, we are obliged to share your information with the HSE for contact tracing purposes. Your information will be kept securely for 30 days by the Guinness Open Gate Brewery.',
				color: 'red'
			},
			{
				header: 'How to book',
				copy: 'To help us deliver a great experience, we are asking all guests to book online in advance. We will not be able to accept walk-ups at this time, so make sure to secure your spot. There will be no cover charge, and all table bookings can be made <a href="https://www.opentable.ie/r/guinness-open-gate-brewery-reservations-dublin?restref=213819&lang=en-IE&ot_source=Restaurant%20website">here</a>.<br/><br/>To ensure the safety of our visitors and staff, we will be following all government guidelines. We have reduced the number of people we can welcome at one time, so try not to be late for your booking to get the most out of your time with us at Guinness Open Gate Brewery. If you change your mind, please make sure to cancel in advance and we’ll look forward to welcoming you next time!<br/><br/>If you’ve any special requests, please contact us at <a href="mailto:info@guinnessopengate.com" target="_blank">info@guinnessopengate.com</a>.',
				color: 'green'
			}
		];

		return (
			<div className="welcome" >
				<Header />
				<div className="welcome-page">
					<MetaDetail meta={meta} />
					<div className={'hero hero--active'}>
						<div className={'feature feature--active'}>
							<div className={'hero__container'}>
								<div className={'hero__background'} />
								<div className={'hero__heading-container'}>
									<div className={'hero__text-container'}>
										<h1 className={'hero__title'}>Our Gates <br />are Open</h1>
										<p className={'hero__subhead'}>Here at the Guinness Open Gate Brewery, we are delighted to be able to reopen our gates and welcome you with a long-awaited beer. We want to make sure you feel safe during your visit, so when you arrive things will be a bit different. We have been working hard on delivering a new experience which will tick all your boxes across food and beer.</p>
									</div>
								</div>
							</div>
						</div>
						<div className="hero--waves" />
					</div>
					{items && items.map((item, i) => (
						<div className={'feature feature--active welcome__container'}>
							<div className={`welcome-item__wrap ${i % 2 === 0 ? 'image-right' : 'image-left'} welcome-item__bg--${item.color}`}>
								<div className={'welcome-item__text-container'}>
									<h2 className={'welcome-item__name'}>{item.header}</h2>
									<div className={'welcome-item__separator'} />
									<div className={'welcome-item__desc'} dangerouslySetInnerHTML={{ __html: item.copy }} />
								</div>
								{/* <div className={'welcome-item__image-container'} style={`background-image: url('${item.img}'); background-position: center; background-repeat: no-repeat; background-size: cover`} /> */}
							</div>
						</div>

					))
					}
					{
						newsletterContent.length && signUpFormData &&
						<Newsletter
							content={newsletterContent[0]}
							formData={signUpFormData}
							// fetchData={this.props.fetchData}
							routeProps={this.props.routeProps}
						/>
					}
				</div>
			</div >
		);
	}
}

// 	export default connect(
//   () => ({}),
// 	{buildContentAction}
// ) (WelcomePage);
export default WelcomeBackPage;



// WEBPACK FOOTER //
// ./src/pages/welcome-back/index.js